export abstract class ScalarProvider<ValueType> {
	abstract value: ValueType;
	abstract subscribe(subscriber: ScalarConsumer<ValueType>): typeof subscriber;
	abstract unsubscribe(subscriber: ScalarConsumer<ValueType>): void;
}

export type Scalar<ValueType> = ScalarProvider<ValueType> | ValueType;

export interface ScalarConsumer<ValueType> {
	update(value: ValueType): void;
}

export function scalarValue<Type>(scalar: Scalar<Type>): Type {
	return scalar instanceof ScalarProvider ? scalar.value : scalar;
}

export function onScalarValue<Type>(
	scalar: Scalar<Type>,
	onValue: (value: Type) => void,
	onSubscription?: (scalar: ScalarProvider<Type>, subscriber: ScalarConsumer<Type>) => void
) {
	if (scalar instanceof ScalarProvider) {
		const subscription = scalar.subscribe({ update: onValue });
		onSubscription?.(scalar, subscription);
	} else {
		onValue(scalar);
	}
}
